import { ChangeDetectionStrategy, Component, computed, inject, input, model, signal } from "@angular/core";

import {
  IButtonDirective,
  IIconComponent,
  IInputGroupDirective,
  IInputGroupInput,
  ISelectMenuImports,
  ITooltipDirective,
} from "@front/m19-ui";
import { TranslocoDirective } from "@jsverse/transloco";
import { MediaType } from "@front/m19-api-client";
import { Media } from "@m19-board/shared/media/media";
import { CAMPAIGN_TYPE } from "@front/m19-injection-token";
import { FormsModule } from "@angular/forms";
import { MediaCardComponent } from "@m19-board/shared/media/media-card/media-card.component";
import { MediaImageSize } from "@m19-board/dsp/dsp-creatives/dsp-custom-creatives/dsp-custom-creatives-table/dsp-custom-creatives-lines.component";
@Component({
  selector: "app-media-selection",
  imports: [
    TranslocoDirective,
    IInputGroupInput,
    IInputGroupDirective,
    FormsModule,
    MediaCardComponent,
    IIconComponent,
    ISelectMenuImports,
    IButtonDirective,
    ITooltipDirective,
  ],
  templateUrl: "./media-selection.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MediaSelectionComponent<T extends Media> {
  private readonly campaignType = inject(CAMPAIGN_TYPE, { optional: true });

  readonly medias = input.required<T[]>();
  readonly mediaType = input.required<MediaType>();
  readonly selectedMedia = model<T>();
  readonly imageSizeFilterValues = input<MediaImageSize[]>();

  mediaNameFilter = signal("");
  selectedImageSize = signal<MediaImageSize | undefined>(undefined);

  readonly hasImageSizeFilter = computed(() => (this.imageSizeFilterValues()?.length ?? 0) > 0);

  filteredMedias = computed(() => {
    const nameFilter = this.mediaNameFilter();
    const sizeFilter = this.selectedImageSize();
    return this.medias().filter((m: T) => {
      const regexp = new RegExp(nameFilter, "i");
      if (!regexp.test(m.name!)) {
        return false;
      }
      if (!sizeFilter) {
        return true;
      }
      return m.width === sizeFilter.width && m.height === sizeFilter.height;
    });
  });

  setSelectedMedia(media: T): void {
    this.selectedMedia.set(media);
  }

  clearImageSizeFilter(event: Event): void {
    event.stopPropagation();
    this.selectedImageSize.set(undefined);
  }
}
